import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import useHasPermission from 'hooks/useHasPermission';
import { GetAllCustomerData } from 'pages/Componets/API_Modal/CustomerMasterAPIModal';
import React, { useState } from 'react'
import { Card } from 'react-bootstrap';
import AddProductType from './components/AddMakingType';
import DeleteProductType from './components/DeleteMakingType';

const MakingTypeList = () => {
    const HasPermission = useHasPermission()
    const [addVendorOpen, setAddVendorOpen] = useState(false)
    const [refreshKey, setRefreshKey] = useState(0);
    const [openDelete, setOpenDelete] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [selectedId, setSelectedId] = useState<number | null>(null)

    const reloadDataSource = () => {
        setRefreshKey((prev) => prev + 1);
    };

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: "id",
            load: async (loadOptions) => {
                try {
                    const { searchValue, } = loadOptions;
                    const parameterList = new URLSearchParams();
                    const search = JSON.parse(JSON.stringify(loadOptions));
                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }

                    if (searchValue) {
                        parameterList.append("search", searchValue);
                    }

                    const response = await GetAllCustomerData(parameterList);
                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            },
        });
    };
    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className="m-0" >Making Type</h5>
                            {HasPermission("GoldRateMaster.Write") && <>
                                <button className="btn btn-sm"
                                    style={{ border: "1px solid #000" }}
                                    type="button"
                                    onClick={() => setAddVendorOpen(!addVendorOpen)}
                                >
                                    <i className="bi bi-plus-lg"></i> Add Making Type
                                </button>

                                <AddProductType selectedId={null} isAddProductTypeOpen={addVendorOpen} onClose={() => setAddVendorOpen(!addVendorOpen)} reloadDataSource={reloadDataSource} />
                            </>
                            }
                        </Card.Header>
                        <Card.Body>
                            {HasPermission("Customer.Read") ? (
                                <DataGrid
                                    dataSource={dataSource()}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    key={refreshKey}
                                    showBorders={true}
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}
                                >
                                    <Pager
                                        showPageSizeSelector
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons
                                        displayMode="full"
                                        showInfo
                                    />
                                    <Scrolling
                                        mode="standard"
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />
                                    <SearchPanel
                                        visible={true}
                                        width={240}
                                        placeholder="Search..."
                                    />
                                    <Summary>
                                        <TotalItem />
                                    </Summary>
                                    <Paging defaultPageSize={10} />

                                    {(HasPermission("Customer.Write") ||
                                        HasPermission("Customer.Delete")) && (
                                            <Column
                                                allowFiltering={false}
                                                caption="Action"
                                                width='15%'
                                                cssClass="text-center"
                                                cellRender={({ data }) => (
                                                    <div className="d-flex justify-content-center align-items-center gap-2">
                                                        {HasPermission("Customer.Delete") && (
                                                            <button
                                                                className="btn btn-sm action-btn delete-btn"
                                                                title="Delete Vendor"
                                                                onClick={() => {
                                                                    setOpenDelete(!openDelete)
                                                                    setSelectedId(data.id)
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} className="ml-2" />
                                                            </button>
                                                        )}
                                                        {HasPermission("Customer.Write") && (
                                                            <button
                                                                className="btn btn-sm action-btn edit-btn"
                                                                title="Edit Vendor"
                                                                onClick={() => {
                                                                    setOpenEdit(!openEdit)
                                                                    setSelectedId(data.id)
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faPenToSquare} className="ml-2" />
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            />
                                        )}
                                    <Column
                                        dataField="id"
                                        dataType="number"
                                        sortOrder="desc"
                                        width={150}

                                        visible={false}
                                    />
                                    <Column
                                        dataField="firstName"
                                        caption="Making Type"
                                        width={150}
                                        dataType="string"
                                    />
                                </DataGrid>
                            ) : (
                                null
                            )}
                        </Card.Body>
                    </Card>
                </div>
            </div>

            <DeleteProductType
                isDeleteProductTypeOpen={openDelete}
                onClose={() => {
                    setOpenDelete(!openDelete)
                    setSelectedId(null)
                }}
                reloadDataSource={reloadDataSource}
                selectedId={selectedId} />

            <AddProductType
                isAddProductTypeOpen={openEdit}
                onClose={() => {
                    setOpenEdit(!openEdit)
                    setSelectedId(null)
                }}
                reloadDataSource={reloadDataSource}
                selectedId={selectedId}
            />
        </>
    )
}

export default MakingTypeList
